import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { ProjetoCadastroService } from "../services/projeto-cadastro.service";
import { StorageService } from "src/app/shared/services/storage.service";

@Injectable({
  providedIn: 'root'
})
export class ProjetoCadastroResolver implements Resolve<boolean> {

  constructor(private service: ProjetoCadastroService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.parent.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjetoCadastroCombosResolver implements Resolve<boolean> {

  constructor(private service: ProjetoCadastroService) { }

  resolve(): Observable<any> {
    return this.service.listCombos();
  }
}


@Injectable({
  providedIn: 'root'
})
export class ProjetoCadastroFiltersResolver implements Resolve<boolean> {

  constructor(private service: ProjetoCadastroService, private storageService: StorageService) { }

  resolve(): Observable<any> {
    let filterValue = this.storageService.getFilterValue('filterPreProjetoValue');
    return this.service.listFilters(filterValue ?? []);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjetoCadastroMenuResolver implements Resolve<boolean> {

  constructor(private service: ProjetoCadastroService, private storageService: StorageService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getMenu(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjetoCadastroAbasResolver implements Resolve<boolean> {

  constructor(private service: ProjetoCadastroService, private storageService: StorageService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.service.getByIdTabs(route.parent.params.id, {tab_id: route.params.tab_id});
  }
}